
import React from 'react';

export const SimpleToaster: React.FC = () => {
  return null; // Simple placeholder for now
};
